import { createSelector } from '@reduxjs/toolkit';

const getallowPaperDueDate = state => state.data.dates.allowPaperDueDate;
const getCurrentDate = state => state.currentDate;

export const getAllowPaper = createSelector(getallowPaperDueDate, getCurrentDate, (allowPaperDueDate, currentDate) => {
    return currentDate <= allowPaperDueDate;
});
